"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _text = require("./text");

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObjHandler = function () {
    function ObjHandler() {
        _classCallCheck(this, ObjHandler);
    }

    _createClass(ObjHandler, null, [{
        key: "getChild",


        // get child or child of child or child of child of child...
        // Key can be "key.otherKey"
        value: function getChild(obj, key) {
            var arr = key.split(".");
            while (arr.length && (obj = obj[arr.shift()])) {}
            return obj;
        }
    }, {
        key: "sortByKey",
        value: function sortByKey(objArray, key) {
            return objArray.sort(function (item, lastItem) {
                var name = _text2.default.replaceSpecial(item[key].toUpperCase());
                var last = _text2.default.replaceSpecial(lastItem[key].toUpperCase());
                if (name < last) {
                    return -1;
                } else if (name > last) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }

        // Remove objects with a duplicate key from array of objects
        // (will keep the last found)

    }]);

    return ObjHandler;
}();

ObjHandler.removeDuplicates = function (objArray, key) {
    var newArray = [];

    var _loop = function _loop(index) {
        var foundIndex = null;
        var found = newArray.find(function (relation, i) {
            if (ObjHandler.getChild(relation, key) === ObjHandler.getChild(objArray[index], key)) {
                foundIndex = i;
                return true;
            }
            return false;
        });
        if (found === undefined) {
            newArray.push(objArray[index]);
        } else {
            newArray[foundIndex] = found;
        }
    };

    for (var index in objArray) {
        _loop(index);
    }
    return newArray;
};

exports.default = ObjHandler;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@app-masters/js-lib/dist/objHandler.js
// module id = 892
// module chunks = 0